import * as CryptoJS from 'crypto-js';
export const allConstant = {
    paymentStatus: [
        "Pending",
        "Payment received",
        "Pending For Approval",
        "Approved",
        "Released Invoice"
    ],
    globaluserType: [
        "",
        "admin",
        "saler",
        "saler",
        "buyer",
        "buyer",
        "Manager",
        "Cashier",
        "Data Entry"

    ],
    secretKey: 'Aca@1234567890123456789012345678',
    iv: CryptoJS.enc.Utf8.parse('Aca@123456789123'),
    internetSpeadCheck:{
        latency:500,
        download:500,
        upload:500,
        netSpeedMbps: 1,
    },
    bidSetting:{
        bidTimeGap: 2,
    }
} 